import { useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { Form, Select } from 'components/common/form';

type Category = { id: number; title: string };

interface Props {
  getCategoryId: (categoryId: number) => void;
}

const AnalyticsCoursesCategoryFilter = ({ getCategoryId }: Props) => {
  const { messages } = useReduxState();

  const { data } = useApiData({ url: '/admin/categories-courses' });

  if (!data?.categories) return null;

  const options = [
    { label: messages.commonAllCategories, value: 0 },
    ...(data?.categories
      ? data.categories.map((category: Category) => ({
          label: category.title,
          value: category.id
        }))
      : [])
  ];

  const initialValues = { categoryId: 0 };

  return (
    <div className="filter">
      <Form initialValues={initialValues}>
        <Select
          field="categoryId"
          id="categoryId"
          isSearchable={true}
          onChange={(categoryId: number) => getCategoryId(categoryId)}
          options={options}
        />
      </Form>
    </div>
  );
};

export default AnalyticsCoursesCategoryFilter;
